import { AppTabs } from 'shared/UI/UIKit/Tab';
import { AppLoader } from 'shared/UI/UIKit/Loader';
import type { Month } from '../../types';
import type { CalendarEvent } from '../../List/model/types';
import { useProductionCalendarTabsService } from '../model';
import { CalendarList } from '../../List';

interface ProductionCalendarTabsProps {
  selectedTab?: string;
  onSelectTab: (tab: string) => void;
  showCreateModal: (month: Month) => void;
  refreshTrigger: number;
  showEditModal: (month: Month, calendarEvent: CalendarEvent) => void;
  showDeleteModal: (calendarEvent: CalendarEvent) => void;
}

export const ProductionCalendarTabs = ({
  selectedTab,
  onSelectTab,
  showCreateModal,
  refreshTrigger,
  showDeleteModal,
  showEditModal,
}: ProductionCalendarTabsProps) => {
  const {
    state: { tabs, loading },
  } = useProductionCalendarTabsService({ onSelectTab });

  if (loading) {
    return <AppLoader />;
  }

  return (
    <AppTabs onChange={onSelectTab} defaultActiveKey={selectedTab} activeKey={selectedTab}>
      {tabs.map((tab) => (
        <AppTabs.TabPane key={tab.key} tab={tab.name}>
          <div style={{ overflowY: 'scroll', maxHeight: '70vh' }}>
            <CalendarList
              key={tab.key}
              calendarYear={tab.key}
              showCreateModal={showCreateModal}
              refreshTrigger={refreshTrigger}
              showDeleteModal={showDeleteModal}
              showEditModal={showEditModal}
            />
          </div>
        </AppTabs.TabPane>
      ))}
    </AppTabs>
  );
};
